import { render, staticRenderFns } from "./FolderListItem.vue?vue&type=template&id=37b65dd5&scoped=true"
import script from "./FolderListItem.vue?vue&type=script&lang=ts"
export * from "./FolderListItem.vue?vue&type=script&lang=ts"
import style0 from "./FolderListItem.vue?vue&type=style&index=0&id=37b65dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b65dd5",
  null
  
)

export default component.exports